import type { ListUsersFilters } from '../types/api'

/**
 * Translate directory filters into the admin users query string. Accepts the older
 * `page`/`page_size`, `account_state` and `school_id` shapes so existing callers keep working.
 */
export function toUsersQuery(filters: ListUsersFilters): Record<string, unknown> {
  const {
    page,
    page_size,
    limit,
    offset,
    account_state,
    disabled,
    school_id,
    school_ids,
    roles,
    ...rest
  } = filters

  const size = limit ?? page_size
  const schools = school_ids?.length ? school_ids : school_id ? [school_id] : []

  return {
    ...rest,
    disabled: disabled ?? (account_state === 'DISABLED' ? true : undefined),
    roles: roles?.length ? roles.join(',') : undefined,
    school_ids: schools.length ? schools.join(',') : undefined,
    limit: size,
    offset: offset ?? (page && size ? (Math.max(page, 1) - 1) * size : undefined),
    include_school_assignments: true,
  }
}
